import { toIcons } from "../../consts/Paths";
import { HiDownload } from "react-icons/hi";
import useIsMobile from "../../hooks/useIsMobile";

const Slider = (props: any) => {
  const { isMobile } = useIsMobile();
  const classChosen = props.classChosen;

  const contentLayoutDocument = (obj: any) => (
    <div className="document-wrapper">
      <div className="document-name-box">
        <div className="document-icon-wrapper">
          <img className="document-icon" src={`${toIcons}/lookbook.svg`} />
        </div>
        <p className="document-name">
          {obj.name ? obj.name : "Document id: " + obj.id}
        </p>
      </div>
      <HiDownload
        className="download-icon"
        onClick={() => window.open(`${obj[classChosen]}`)}
      />
    </div>
  );

  const renderContent = props.data.map((obj: any, key: number) => {
    return (
      <div
        key={key}
        className={classChosen === "document"?"":`wrapper ${classChosen}`}
        style={{
          backgroundImage: `url(${obj[classChosen]})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          backgroundRepeat: "no-repeat" /* 
          minWidth: isMobile && classChosen === "video" ? "90vw" : "",
          height: isMobile && classChosen === "video" ? "220px" : "", */,
        }}
      >
        {classChosen === "document" ? (
          contentLayoutDocument(obj)
        ) : classChosen === "video" ? (
          <video
            id="myVid"
            src={`${obj[classChosen]} `}
            width={"100%"}
            height={"100%"}
            style={{ borderRadius: "12px" }}
            onMouseOver={(e: any) => {
              e.target.play();
            }}
            onMouseOut={(e: any) => {
              e.target.pause();
            }}
          />
        ) : (
          ""
        )}
      </div>
    );
  });

  return (
    <div
      className="slider"
      style={{
        width: isMobile ? "calc(345px - 80px)" : "",
        margin: isMobile ? "0" : "",
      }}
    >
      {renderContent}
    </div>
  );
};
export default Slider;
